/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconIceCream2 = createReactComponent("outline", "ice-cream-2", "IconIceCream2", [["path", { "d": "M17.657 11a6 6 0 1 0 -11.315 0", "key": "svg-0" }], ["path", { "d": "M6.342 11l5.658 11l5.657 -11z", "key": "svg-1" }]]);

export { IconIceCream2 as default };
//# sourceMappingURL=IconIceCream2.mjs.map
